import type { ReactNode } from 'react';
import { FormattedMessage, type MessageDescriptor } from 'react-intl';

import type { CreditLimitReachedUpgradeCopy } from './types';

function isMessageDescriptor(
  value: CreditLimitReachedUpgradeCopy
): value is MessageDescriptor {
  return (
    typeof value === 'object' &&
    value !== null &&
    'id' in value &&
    'defaultMessage' in value
  );
}

export function renderCreditLimitReachedUpgradeCopy(
  content: CreditLimitReachedUpgradeCopy,
  values?: Record<string, string | number>
): ReactNode {
  if (isMessageDescriptor(content)) {
    return <FormattedMessage {...content} values={values} />;
  }

  return content;
}
